export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'RESIDENCES_SET':
    return payload
  case 'RESIDENCE_LOGOUT':
    return []
  default:
    return state
  }
}
